import Link from "next/link";
import { Label } from 'reactstrap'
import useTranslation from 'hooks/UseTranslation'

const GurusExtra = ({ gurus }) => {
    const { t } = useTranslation();
    return gurus?.length > 0 && (
        <div className='mt-2'>
            <Label className='mb-0 form-label'>
                {t('listing_gurus_extra_title')}
            </Label>
            <ul className='list-unstyled mb-0'>
                {
                    gurus.map((guru, index) => (
                        <li className='mb-3' key={guru.id}> 
                            <Link  href={`/@${guru.slug}`}>
                                <a className='text-first-letter'>
                                    <i className='fas fa-user fa-fw text-muted mr-2' />
                                    {guru.name_display}
                                </a>
                            </Link>
                        </li>
                    ))
                }
            </ul>
        </div>
    )
}

export default GurusExtra;